function loadSwatches($swatchBlocks) {
  if ($swatchBlocks.length) {
    $swatchBlocks.each(function(){
      let $swatchBlock = $(this);

      $swatchBlock.addClass('card__swatches--loading');

      let currentProductID = $swatchBlock.data('productId');
      let host = $swatchBlock.data('host');

      if (currentProductID && host) {
        $.getJSON(
          "https://s-pc.webyze.com/ProductColors/productGroup-" + host.split(".")[0] + "-" + currentProductID + ".json", 
          function(response){
            if (response.data && response.data.length) {
              let html = '';
              let products = [];

              for (let i=0; i<response.data.length; i++) {
                let title = /*response.data[i].title + ": " + */response.data[i].name;
                let title_for_link = title.replace(/&/g, "&amp;")
                                           .replace(/</g, "&lt;")
                                           .replace(/>/g, "&gt;")
                                           .replace(/"/g, "&quot;")
                                           .replace(/'/g, "&#039;");
                let image = response.data[i].image;

                if (response.data[i].data && response.data[i].data != '') {
                  image = 'https://s-pc.webyze.com/ProductColors/uploads/' + response.data[i].data;
                }

                if (response.data[i].handle && ((title && title != '') || (image && image != ''))) {
                  html += "<li class=\"card__variants-by-color__item"
                          + ((currentProductID == response.data[i].id) ? " card__variants-by-color__item--current" : "") +"\" data-num=\""+ i +"\">" 
                            + "<a class=\"card__variants-by-color__item-link\" href=\"#\" title=\""+ title_for_link +"\">" 
                              + "<span class=\"card__variants-by-color__item-image\" style=\"background-image:url('"+ image +"');\"></span>"
                              + "<span class=\"card__variants-by-color__item-title\">"+ title +"</span>"
                            + "</a>"
                          + "</li>";
                  products.push({num: i, handle: response.data[i].handle});
                }
              }

              if (html != '') {
                $swatchBlock.prepend('<ul class="card__variants-by-color">'+ html +'</ul>');

                for (let j=0; j<products.length; j++) {
                  $.getJSON("https://" + window.location.host + "/products/" + products[j].handle + ".js", function(response2){
                    if (response2.url) {
                      $swatchBlock.find('li[data-num="'+ products[j].num +'"] a').attr('href', response2.url);
                    } else {
                      $swatchBlock.find('li[data-num="'+ products[j].num +'"]').remove();
                    }
                  })
                  .fail(function(){
                    $swatchBlock.find('li[data-num="'+ products[j].num +'"]').remove();
                  });
                }
              } else {
                $swatchBlock.remove();
              }
            } else {
              $swatchBlock.remove();
            }
        }).always(function() {
          let $swatchesListBlock = $swatchBlock.find('.card__variants-by-color');
          let $swatchesListItems = $swatchesListBlock.children();

          if (!$swatchesListBlock.length || !$swatchesListItems.length) {
            $swatchBlock.remove();
          } else {
            let countText = $swatchesListItems.length + ' '+ (($swatchesListItems.length) > 1 ? window.swatchesStrings.manyColors : window.swatchesStrings.singleColor);

            $swatchBlock.prepend('<div class="card__swatches-count">'+ countText +'</div>');
            $swatchBlock.addClass('card__swatches--loaded');
            $swatchBlock.removeClass('card__swatches--loading');
          }
        })
        .fail(function() {
          $swatchBlock.remove();
        });
      } else {
        $swatchBlock.remove();
      }
    });
  }
}

function watchSwatches() {
  let $swatchBlocks = $('.product-grid.enable-color-swatches .grid__item .card__swatches--color:not(.card__swatches--loaded):not(.card__swatches--loading)');

  if ($swatchBlocks.length) {
    loadSwatches($swatchBlocks);
    
    $(document).on('collectionfilterapplied', function(){
      let $filteredSwatchBlocks = $('.product-grid.enable-color-swatches .grid__item .card__swatches--color:not(.card__swatches--loaded):not(.card__swatches--loading)');

      if ($filteredSwatchBlocks.length) {
        loadSwatches($filteredSwatchBlocks);
      }
    });
  }
}


class VideoBanner {
  constructor(sectionID, sectionType = 'image-banner') {
    this.sectionID = sectionID;
    this.sectionType = sectionType;
    this.ready = false;
    this.video = null;
    this.videoWrapper = null;
    this.outerWrapper = null;
    this.playButton = null;
    this.soundButton = null;
    this.expandButton = null;
    this.videoPlaying = false;
    this.audioPlaying = false;
    this.expanded = false;
    this.soundTimeoutID = null;
    this.videoTimeoutID = null;
    this.expandTimeoutID = null;
    this.classNames = null;

    if (this.sectionType == 'image-banner') {
      this.classNames = {
        video: 'banner__video',
        wrapper: 'banner__media--video',
        wrapperVideoOn: 'banner__media--video-on',
        wrapperVideoEnded: 'banner__media--video-ended',
        wrapperAudioOn: 'banner__media--sound-on',
        outerWrapper: 'banner--video',
        outerWrapperExpanded: 'banner--expanded',
        playButton: 'banner__video-play',
        soundButton: 'banner__video-sound',
        expandButton: 'banner__video-expand'
      }
    } else if (this.sectionType == 'video') {
      this.classNames = {
        video: 'video-section__video',
        wrapper: 'video-section__media',
        wrapperVideoOn: 'video-section__media--on',
        wrapperVideoEnded: 'video-section__media--ended',
        wrapperAudioOn: 'video-section__media--sound-on',
        playButton: 'video-section__video-play',
        soundButton: 'video-section__video-sound'
      }
    }

    this.init();
  }

  init() {
    this.video = document.querySelector('#shopify-section-'+ this.sectionID +' .'+ this.classNames.video);
    this.videoWrapper = document.querySelector('#shopify-section-'+ this.sectionID +' .'+ this.classNames.wrapper);
    this.playButton = document.querySelector('#shopify-section-'+ this.sectionID +' .'+ this.classNames.playButton);
    this.soundButton = document.querySelector('#shopify-section-'+ this.sectionID +' .'+ this.classNames.soundButton);

    if (this.sectionType == 'image-banner') {
      this.outerWrapper = document.querySelector('#shopify-section-'+ this.sectionID +' .'+ this.classNames.outerWrapper);
      this.expandButton = document.querySelector('#shopify-section-'+ this.sectionID +' .'+ this.classNames.expandButton);
    }

    if (this.video && this.videoWrapper) {
      this.ready = true;
    }

    this.setVideoState();
    this.setAudioState();

    if (this.sectionType == 'image-banner') {
      this.setExpandedState();
    }

    this.handleEvents();
  }

  isReady() {
    return this.ready;
  }

  isVideoPlaying() {
    return this.videoPlaying;
  }

  isAudioPlaying() {
    return this.audioPlaying;
  }

  isExpanded() {
    return this.expanded;
  }

  setVideoState() {
    if (this.ready && this.videoWrapper.classList.contains(this.classNames.wrapperVideoOn)) {
      this.videoPlaying = true;
    } else {
      this.videoPlaying = false;
    }
  }

  setAudioState() {
    if (this.ready && this.videoWrapper.classList.contains(this.classNames.wrapperAudioOn)) {
      this.audioPlaying = true;
    } else {
      this.audioPlaying = false;
    }
  }

  setExpandedState() {
    if (this.ready && this.sectionType == 'image-banner' && this.outerWrapper.classList.contains(this.classNames.outerWrapperExpanded)) {
      this.expanded = true;
    } else {
      this.expanded = false;
    }
  }

  handleEvents() {
    let context = this;

    if (this.ready === true && this.playButton) {
      this.video.addEventListener('click', () => {
        context.handleVideoBannerClick();
      });

      this.playButton.addEventListener('click', () => {
        context.handleVideoBannerClick();
      });
    }

    if (this.ready === true && this.soundButton) {
      this.soundButton.addEventListener('click', () => {
        context.handleSoundButtonClick();
      });
    }

    if (this.ready === true && this.expandButton) {
      this.expandButton.addEventListener('click', () => {
        context.handleExpandButtonClick();
      });
    }
  }

  handleVideoBannerClick() {
    if (this.ready === true) {
      let context = this;

      if (this.videoTimeoutID) {
        clearTimeout(this.videoTimeoutID);
      }

      if (this.isVideoPlaying()) {
        this.video.pause();
        this.videoWrapper.classList.remove(this.classNames.wrapperVideoOn);
      } else {
         if (!this.video.ended || this.video.loop === true) {
           this.videoWrapper.classList.add(this.classNames.wrapperVideoOn);
           this.video.play();
         } else {
           this.videoWrapper.classList.add(this.classNames.wrapperVideoEnded);
         }
      }

      this.videoTimeoutID = setTimeout(function() {
        context.setVideoState();
      }, 500);
    }
  }

  handleSoundButtonClick() {
    if (this.ready === true) {
      let context = this;

      if (this.soundTimeoutID) {
        clearTimeout(this.soundTimeoutID);
      }

      if (this.isAudioPlaying()) {
        this.video.muted = true;
        this.videoWrapper.classList.remove(this.classNames.wrapperAudioOn);
      } else {
        this.videoWrapper.classList.add(this.classNames.wrapperAudioOn);
        this.video.muted = false;
      }

      this.soundTimeoutID = setTimeout(function() {
        context.setAudioState();
      }, 500);
    }
  }

  handleExpandButtonClick() {
    if (this.ready === true) {
      let context = this;

      if (this.expandTimeoutID) {
        clearTimeout(this.expandTimeoutID);
      }

      if (this.isExpanded()) {
        this.outerWrapper.classList.remove(this.classNames.outerWrapperExpanded);
      } else {
        this.outerWrapper.classList.add(this.classNames.outerWrapperExpanded);
      }

      this.expandTimeoutID = setTimeout(function() {
        context.setExpandedState();
      }, 500);
    }
  }
}


function modifyGloboCrossSellSlider(globoProducts) {
  if (!globoProducts.length) {
    return;
  }

  globoProducts.forEach(product => {
    if (!product.href) {
      return;
    }

    let request = new XMLHttpRequest();

    request.open('GET', product.href + '.js', true);

    request.onload = (event) => {
      if (request.status >= 200 && request.status < 400) {
        // Success!
        let data = JSON.parse(request.responseText);

        if (data && data.images && data.images.length > 1) {
          const imageWrapper = document.createElement('div');

          imageWrapper.className = 'ga-product_image ga-product_image_'+ data.id + '_2';
          imageWrapper.setAttribute('id', 'ga-product_image_'+ data.id +'_2');
          imageWrapper.setAttribute('style', "background-image: url('"+ data.images[1] +"')");
          imageWrapper.innerHTML = '<span></span>';

          product.appendChild(imageWrapper);
        }
      } else {
        console.log('modifyGloboCrossSellSlider: getting product '+ product.href +'. We reached our target server, but it returned an error');
        console.log('modifyGloboCrossSellSlider: request.onload event obj');
        console.log(event);
        console.log('modifyGloboCrossSellSlider: request.onload request obj');
        console.log(request);
      }
    };

    request.onerror = (event) => {
      console.log('modifyGloboCrossSellSlider: getting product '+ product.href +' caused a connection error of some sort');
      console.log('modifyGloboCrossSellSlider: request.onerror event obj');
      console.log(event);
      console.log('modifyGloboCrossSellSlider: request.onerror request obj');
      console.log(request);
    };

    request.send();
  });
}

function watchGloboCrossSellSlider() {
  const completeTheLook = document.getElementById('complete-the-look');

  if (!completeTheLook) {
    return;
  }

  const config = { childList: true, subtree: true };
  let count = 0;

  const callback = (mutationList, observer) => {
    if (!count) {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length) {
          mutation.addedNodes.forEach(nodeItem => {
            if (!count && nodeItem.tagName && nodeItem.tagName == 'DIV' && (nodeItem.classList.contains('gowl-nav') || nodeItem.classList.contains('gowl-dots'))) {
              const globoProducts = document.querySelectorAll('.gowl-carousel .ga-product > a:first-child');

              if (globoProducts.length) {
                count++;
                observer.disconnect();
                modifyGloboCrossSellSlider(globoProducts);
                return;
              }
            }
          });
        }
      }
    }
  };

  const observer = new MutationObserver(callback);

  observer.observe(completeTheLook, config);
}


function pageAnchorsSmoothScroll() {
  document.body.addEventListener("click", function(e) {
	if (e.target && e.target.nodeName == "A" && e.target.href && e.target.href.lastIndexOf('#') != -1) {
      let linkParts = e.target.href.split('#');

      if (!linkParts[1]) {
        return;
      }

      const scrollTarget = document.getElementById(linkParts[1]);

      if (!scrollTarget) {
        return;
      }

      e.preventDefault();

      window.setTimeout(() => {
        scrollTarget.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

        let currentHashIndex = window.location.href.lastIndexOf('#');
        let newURL = window.location.href;

        if (currentHashIndex != -1) {
          newURL = window.location.href.replace(window.location.href.slice(currentHashIndex + 1), linkParts[1]);
        } else {
          newURL += '#'+ linkParts[1];
        }

        window.history.pushState({}, document.getElementsByTagName("title")[0].innerHTML +' #'+ linkParts[1] , newURL);
      });
	}
  });
}


class LayoutSwitcher {
  constructor(sectionID) {
    this.sectionID = sectionID;
    this.ready = false;
    this.options = null;
    this.activeOption = null;
    this.grid = null;
    this.columns = null;
    this.prevColumns = null;

    this.init();
  }

  init() {
    this.swither = document.querySelector('#shopify-section-'+ this.sectionID +' .layout-switcher');
    this.options = document.querySelectorAll('#shopify-section-'+ this.sectionID +' .layout-switcher__option[data-grid-items]');
    this.activeOption = document.querySelector('#shopify-section-'+ this.sectionID +' .layout-switcher__option--active[data-grid-items]');
    this.grid = document.querySelector('#shopify-section-'+ this.sectionID +' .product-grid');

    if (this.swither && this.options&& this.activeOption && this.grid) {
      this.ready = true;
    }

    if (this.ready) {
      this.setColumns();
      this.handleEvents();
    }
  }

  isReady() {
    return this.ready;
  }

  setActiveOption(option) {
    if (this.ready) {
      this.activeOption = option;

      this.options.forEach((options_item) => {
        if (options_item.classList.contains('layout-switcher__option--active')) {
          options_item.classList.remove('layout-switcher__option--active');
        }
      });

      this.activeOption.classList.add('layout-switcher__option--active')
    }
  }

  setColumns() {
    if (this.ready) {
      if (this.columns) {
        this.prevColumns = this.columns;
      }
  
      this.columns = this.activeOption.dataset.gridItems;
    }
  }

  switchLayout() {
    if (this.ready) {
      if (!this.grid.classList.contains('grid--'+ this.columns +'-col')) {
        this.grid.classList.add('grid--'+ this.columns +'-col');
  
        if (this.prevColumns) {
          this.grid.classList.remove('grid--'+ this.prevColumns +'-col');
        }
      }
    }
  }

  handleEvents() {
    if (this.ready) {
      let context = this;

      this.options.forEach((options_item) => {
        options_item.addEventListener('click', (e) => {
          context.handleOptionClick(options_item);
        });
      });
    }
  }

  handleOptionClick(option) {
    if (this.ready && option !== this.activeOption) {
      this.setActiveOption(option);
      this.setColumns();
      this.switchLayout();
    }
  }
}


function setdetailsHeight(details, summary, content) {
  if (details.classList.contains('opened')) {
    details.style.height = summary.offsetHeight + content.offsetHeight + 'px';
  } else {
    details.style.height = summary.offsetHeight + 'px';
  }
}

function initDetailsAnimations() {
  const animatedDetails = document.querySelectorAll('details.details-animated');

  if (animatedDetails && animatedDetails.length) {
    animatedDetails.forEach((details) => {
      const detailsSummary = details.querySelector('summary');
      const detailsContent = details.querySelector('summary ~ *');

      let resizeTimeout = null;

      details.style.height = detailsSummary.offsetHeight + 'px';
      
      if (!details.hasAttribute('open')) {
        details.open = true;
      }

      details.addEventListener('toggle', (event) => {
        event.preventDefault();
        details.open = true;
      });

      detailsSummary.addEventListener('click', (event) => {
        event.preventDefault();
        details.open = true;

        if (details.classList.contains('opened')) {
          details.style.height = detailsSummary.offsetHeight + 'px';
          details.classList.remove('opened');
        } else {
          details.style.height = detailsSummary.offsetHeight + detailsContent.offsetHeight + 'px';
          details.classList.add('opened');
        }

        details.dispatchEvent(new CustomEvent('detailsToggle', {bubbles: true, detail: {
          detailsElement: details,
          summaryElement: detailsSummary,
          contentElement: detailsContent
        }}));
      });

      details.addEventListener('detailsToggle', (event) => {
        if (details !== event.target) {
          clearTimeout(resizeTimeout);

          resizeTimeout = setTimeout(function(){
            setdetailsHeight(details, detailsSummary, detailsContent);
          }, 300);
        }
      });

      details.addEventListener('detailsResized', (event) => {
        if (details !== event.target) {
          clearTimeout(resizeTimeout);

          resizeTimeout = setTimeout(function(){
            setdetailsHeight(details, detailsSummary, detailsContent);
          }, 300);
        }
      });

      window.addEventListener("load", () => {
        setdetailsHeight(details, detailsSummary, detailsContent);
      });

      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(function(){
          setdetailsHeight(details, detailsSummary, detailsContent);
          details.dispatchEvent(new CustomEvent('detailsResized', { bubbles:true, detail: {
            detailsElement: details,
            summaryElement: detailsSummary,
            contentElement: detailsContent
          }}));
        }, 300);
      });

      document.addEventListener('click', (event) => {
        if (
          (details !== event.target && !details.contains(event.target) && details.classList.contains('details-animated--auto-close')) || 
          (details.contains(event.target) && event.target.classList.contains('select__dropdown-option'))
        ){
          details.style.height = detailsSummary.offsetHeight + 'px';
          details.classList.remove('opened');
        }
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initDetailsAnimations();
});


function initAlwaysOpenedDetails() {
  const alwaysOpenedDetails = document.querySelectorAll('details.details-always-open');

  if (alwaysOpenedDetails && alwaysOpenedDetails.length) {
    alwaysOpenedDetails.forEach((details) => {
      const detailsSummary = details.querySelector('summary');

      if (!details.hasAttribute('open')) {
        details.open = true;
      }

      details.addEventListener('toggle', (event) => {
        event.preventDefault();
        details.open = true;
      });

      detailsSummary.addEventListener('click', (event) => {
        event.preventDefault();
        details.open = true;
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initAlwaysOpenedDetails();
});